import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, Row, Col, Card } from "react-bootstrap";

const ReservationCardSkeleton = () => (
  <Container>
    <Row className="image-hotel-wrapper g-0">
      <Col sm={12} md={6} className="image-wrapper">
        <Skeleton height={180} />
      </Col>
      <Col className="h-100">
        <Row className="h-100 px-md-4 ps-2 pt-3 g-0">
          <Col>
            <Skeleton height={20} className="mb-2" />
            <Skeleton width="60%" height={20} className="mb-2" />
            <Skeleton width="80%" />
            <Skeleton width="40%" className="mt-2" />
            <Skeleton width="90%" className="mt-2" />
          </Col>
        </Row>
      </Col>
    </Row>
    <Card>
      <Row className="mb-3 mt-3">
        <Col>
          <Skeleton width="80%" height={20} />
        </Col>
        <Col xs={12}>
          <Skeleton width="70%" height={20} />
        </Col>
        <Col xs={12} className="phone-link">
          <Skeleton width="50%" height={20} />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col className="mb-4 d-flex res-links">
          <Skeleton width="30%" height={30} />
        </Col>
      </Row>
      <Skeleton width="100%" height={20} count={3} />
    </Card>
  </Container>
);

export default ReservationCardSkeleton;
